import classNames from 'classnames';
import { IconChevron } from 'components/Icons';
import { prefixClass } from 'lib/utils';
import React, { useEffect, useRef, useState } from 'react';
import { Tooltip, Whisper } from 'rsuite';

interface FormUrlProps {
  routePath: (string | null | undefined)[];
}

const FormURL: React.FC<FormUrlProps> = ({ routePath }) => {
  const prefix = prefixClass('transaction-header-breadcrumb');
  const [containerWidth, setContainerWidth] = useState(0);
  const containerRef = useRef<HTMLDivElement>(null);

  // Let's dinamically check if the container is too narrow to display the text and adpat if needed
  useEffect(() => {
    const containerEl = containerRef.current;
    if (!containerEl) return;

    // Initial size measurement
    setContainerWidth(containerEl.offsetWidth);

    const checkElementWidths = () => {
      const middleItems = document.querySelectorAll('.middle-item');
      middleItems.forEach(item => {
        // Reset the class for all items to be able to meause the width of the container
        item.classList.remove('too-narrow');
        if (item.getBoundingClientRect().width < 40) {
          item.classList.add('too-narrow');
        }
      });
    };

    const observer = new ResizeObserver(entries => {
      for (const entry of entries) {
        // Use contentRect for more accurate measurements
        const width = entry.contentRect.width;
        //setContainerWidth(width);
        checkElementWidths();
      }
    });

    observer.observe(containerEl);
    return () => observer.disconnect();
  }, []);

  if (routePath.length === 0) return null;
  const qualifiedPath = routePath.join(' > ');

  return (
    <div className={prefix()} ref={containerRef}>
      {routePath.map((path, index) => {
        const isFirst = index === 0;
        const isLast = index === routePath.length - 1;

        return (
          <div
            key={index}
            className={classNames(prefix('item'), {
              'first-item': isFirst,
              'last-item': isLast,
              'middle-item': !isFirst && !isLast,
            })}
          >
            <Whisper placement="bottom" trigger="hover" delayOpen={400} speaker={<Tooltip>{qualifiedPath}</Tooltip>}>
              <div className={prefix('item-content')}>{path}</div>
            </Whisper>
            {index < routePath.length - 1 && (
              <div className={prefix('separator')}>
                <IconChevron />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default FormURL;
